import React, { FC, ReactNode } from 'react';
import { ReactComponent as NoUsersSvg } from 'assets/svgs/empty-states/no-users.svg';
import { EmptyState as EmptyStateAtom } from 'components/atoms/empty-state';
import { useTranslation } from 'hooks/use-translation';

const EmptyState: FC = () => (
  <EmptyStateAtom
    image={<NoUsersSvg />}
    message={useTranslation('settings.timesheets.controls.exclusion.no_data')}
  />
);

export const emptyState = (): ReactNode => <EmptyState />;
